import React from 'react';
import { TEES, DISTANCES, totalFor } from './courseData';

export const TeeDot = ({ color, size = 'w-3 h-3' }) => (
  <span
    className={`${size} rounded-full inline-block flex-none`}
    style={{ background: color, boxShadow: color === '#ffffff' ? 'inset 0 0 0 1px rgba(0,0,0,.35)' : 'inset 0 0 0 1px rgba(255,255,255,.25)' }}
    aria-hidden="true"
  />
);

const TeeSelector = ({ tee, hole, onChange }) => {
  const valueFor = (id) => (hole ? DISTANCES[id][hole - 1] : totalFor(id));
  const max = Math.max(...TEES.map((t) => valueFor(t.id)));
  return (
    <div data-testid="tee-selector">
      <div className="font-montserrat text-white/45 text-[10px] tracking-[0.22em] uppercase mb-2">
        Départ <span className="text-white/25 normal-case tracking-normal ml-1">— {hole ? 'distance du trou' : 'longueur totale'}</span>
      </div>
      <div role="radiogroup" aria-label="Choix du départ" className="flex flex-col gap-0.5">
        {TEES.map((t) => {
          const on = tee === t.id;
          const v = valueFor(t.id);
          return (
            <button
              key={t.id}
              type="button"
              role="radio"
              aria-checked={on}
              onClick={() => onChange(t.id)}
              data-testid={`tee-${t.id}`}
              className={`group flex items-center gap-2.5 w-full min-h-[30px] px-2 -mx-2 rounded-lg text-left transition-colors duration-300
                focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#c9a962]
                ${on ? 'bg-[#c9a962]/12' : 'hover:bg-white/[0.05]'}`}
            >
              <TeeDot color={t.color} size="w-2.5 h-2.5" />
              <span className={`font-montserrat text-[11px] w-11 ${on ? 'text-white font-medium' : 'text-white/55 group-hover:text-white/80'}`}>{t.label}</span>
              <span className="flex-1 h-1 bg-white/10 rounded-full overflow-hidden">
                <span
                  className={`block h-full rounded-full transition-[width,background-color] duration-700 ease-out ${on ? 'bg-[#c9a962]' : 'bg-white/30'}`}
                  style={{ width: `${(v / max) * 100}%` }}
                />
              </span>
              <span className={`font-montserrat text-xs tabular-nums w-14 text-right ${on ? 'text-[#c9a962] font-medium' : 'text-white/55'}`} data-testid={`tee-${t.id}-value`}>
                {v.toLocaleString('fr-FR')} m
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default TeeSelector;
